import React from 'react'
import Home from '../../home/Home'
import HelpSupport from '../../help-support/HelpSupport'

const HelpView = () => {
  return (
    <div>
         <>
        <Home />
        <HelpSupport />
        </>
    </div>
  )
}

export default HelpView